import React from 'react';
import CheckboxRow from './CheckboxRow';
import StepActions from './StepActions';
import StepShell from './StepShell';

// Final verification step: mark the resource as verified before closing
// the wizard.
export default function StatusStep({
  resource,
  state,
  updateField,
  onNext,
  onCancel,
  loading,
  title = 'Status'
}) {
  const typeLabel = resource?.type || 'figure';

  return (
    <StepShell>
      <h3>{title}</h3>
      <p>Mark this {typeLabel} as verified once it has been checked against the publication.</p>
      <CheckboxRow
        id="status-verified"
        label="Verified"
        checked={Boolean(state?.verified)}
        onChange={(e) => updateField('verified', e.target.checked)}
        disabled={loading}
      />
      <StepActions onNext={onNext} onCancel={onCancel} loading={loading} />
    </StepShell>
  );
}
